module.exports = __webpack_public_path__ + "static/bell-34a9293d28df9112880c77ea5857356d.mp3";